import React, {useEffect, useState} from 'react';
import {FaSearch} from "react-icons/fa";
import {MdOutlineCancel} from "react-icons/md";

const SearchComponent = ({handleSearchSubmit}) => {

    const [searchVal, setSearchVal] = useState("");

    const handleSearchChange = (e) => {
        setSearchVal(e.target.value);
    };

    const submitSearch = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleSearchSubmit(searchVal);
        }
    };

    const handleClearSearch = (e) => {
        e.preventDefault()
        setSearchVal("")
        handleSearchSubmit("");
    }

    return (
        <>
            <div className="input-group mb-3 search-input">
                <div className="input-group-prepend">
                    <span className="input-group-text"><FaSearch/></span>
                </div>
                <input type="search"
                       className="form-control input-search"
                       placeholder={"Pretraga..."}
                       onChange={handleSearchChange}
                       onKeyDown={submitSearch}
                       value={searchVal}
                />
                {searchVal && <div className="input-group-append">
                    <span className="input-group-text" onClick={handleClearSearch}><MdOutlineCancel/></span>
                </div>}
            </div>
        </>
    );
};

export default SearchComponent;
